import {InputValue, Rsvp} from '@wix/ambassador-events-v2-rsvp/types'
import {INPUT_NAMES, getRsvpFormInputValues, getRsvpFormSubmissions} from '@wix/wix-events-commons-statics'
import {RegFormData} from '../types/registration'
import {CurrentMemberDetails, State} from '../types/state'
import {getFormSubmissions} from './rsvp'

export const getCurrentMemberDetails = (state: State): CurrentMemberDetails => state.currentMemberDetails

export const isMember = (state: State) => !!getCurrentMemberDetails(state).id

export const getCurrentMemberId = (state: State) => state.currentMemberDetails?.id

export const getDefaultFormValues = (state: State) => {
  const rsvp = state.memberRsvp?.rsvp as Rsvp

  if (isMember(state) && rsvp) {
    return getRsvpFormSubmissions(rsvp) || {}
  }

  return getFormSubmissions(state) || {}
}

export const getDefaultFormValuesOld = (state: State): Partial<RegFormData> => {
  if (!isMember(state)) {
    return {}
  }

  const rsvp = state.memberRsvp?.rsvp
  const inputValues = rsvp ? getRsvpFormInputValues(rsvp) : undefined

  return inputValues ? mapInputValues(inputValues) : defaultInputValues(state)
}

const mapInputValues = (inputValues: wix.events.InputValue[] | InputValue[]) => {
  const valuesToReturn = {}

  inputValues.forEach(({inputName, values, value}) => {
    const extractedInputName = inputName.split('-')[0]

    if (extractedInputName === INPUT_NAMES.GUEST_NAMES) {
      return
    }

    if (extractedInputName === INPUT_NAMES.ADDITIONAL_GUESTS) {
      valuesToReturn[inputName] = {additionalGuests: value, guestNames: getGuestNames(inputValues)}
    } else {
      valuesToReturn[inputName] = value || (values.length && values) || ''
    }
  })

  return valuesToReturn
}

const defaultInputValues = (state: State) => {
  const {email = '', firstName = '', lastName = ''} = state.currentMemberDetails

  return {
    email,
    firstName,
    lastName,
  }
}

const getGuestNames = (inputValues: wix.events.InputValue[] | InputValue[]) =>
  inputValues
    .find(inputValue => inputValue.inputName === INPUT_NAMES.GUEST_NAMES)
    .values.map(name => {
      const splitName = name.split(' ')

      return {
        firstName: splitName[0],
        lastName: splitName[1],
      }
    })
